var make = require('./make_');
var arrSome = require('../array/some');
var objSome = require('../object/some');

    /**
     */
    module.exports = make(arrSome, objSome);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/some.js
// module id = 1581
// module chunks = 0 1 2